import { useQuery } from "@apollo/client/react";

import { Maybe } from "types/generated";

import { GET_BITBUCKET_CLOUD_INTEGRATION } from "./gql";

const useGetBitbucketCloudIntegration = (id: Maybe<string>) => {
  const { data, loading, error } = useQuery(GET_BITBUCKET_CLOUD_INTEGRATION, {
    variables: {
      id,
    },
    fetchPolicy: "no-cache",
  });

  return {
    integration: data?.bitbucketCloudIntegration,
    isPageLoading: loading && !data?.bitbucketCloudIntegration,
    error,
  };
};

export default useGetBitbucketCloudIntegration;
